export default __webpack_public_path__ + "static/media/plane.b0f2893c.svg";